import Immutable from 'immutable';
import AvailabilityDetailConstants from '../constants/AvailabilityDetailConstants';

const { AVAILABILITY_DETAIL_REQUEST, AVAILABILITY_DETAIL_SUCCESS, AVAILABILITY_DETAIL_ERROR } = AvailabilityDetailConstants;

const initialState = Immutable.Map({
  jacket: {},
  probes: Immutable.Map()
});

export default function availabilityDetail(state = initialState, action) {
  switch (action.type) {

    case AVAILABILITY_DETAIL_REQUEST: {
      return state.set('isFetching', true);
    }

    case AVAILABILITY_DETAIL_SUCCESS: {
      return state.merge({
        ...action.payload,
        isFetching: false
      });
    }

    case AVAILABILITY_DETAIL_ERROR: {
      return state.set('isFetching', false);
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/AvailabilityDetailReducer.js